import React from 'react';

import './ContactAccountTeam.scss';

const ContactAccountTeam = ({ contactAccountTeamProps }) => {
  const { email, location, officePhone, displayName, profilePictureUrl } =
    contactAccountTeamProps;

  return (
    <div className="rm-card">
      <svg
        className="rm-card-heading"
        width={`365`}
        height={`106`}
        viewBox={`0 0 365 106`}
        fill="none"
      ></svg>
      <div className="rm-card-profile-picture">
        <img
          className="rm-headshot"
          alt="contact account team profile"
          src={profilePictureUrl}
        />
      </div>
      <div className="rm-details">
        <div className="rm-details-manager-info">
          <p>{displayName}</p>
          <p>{location ? location : ''}</p>
        </div>
        <div className="rm-contact">
          <div>
            <svg
              className="rm-phone-icon"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="https://www.w3.org/2000/svg"
            >
              <path
                d="M6.1666 5.02905C6.74311 4.45254 6.74311 3.51385 6.1666 2.93733L4.59965 1.37038C4.02314 0.793863 3.08444 0.793863 2.50793 1.37038L1.65054 2.22777C0.90402 2.98167 0.785762 4.1421 1.36967 5.02166C3.86792 8.79859 7.20137 12.1321 10.9783 14.6303C11.8579 15.2142 13.0257 15.0959 13.7648 14.3494L14.6222 13.492C15.1987 12.9155 15.1987 11.9768 14.6222 11.4003L13.0552 9.83337C12.4787 9.25685 11.54 9.25685 10.9635 9.83337L10.4387 10.3581C8.71658 8.94642 7.04615 7.276 5.63442 5.55383L6.1666 5.02905Z"
                stroke="#006894"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.50007 0.956531C12.5601 0.956531 15.0435 3.43999 15.0435 6.49997"
                stroke="#006894"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.50007 3.91299C10.9266 3.91299 12.087 5.07342 12.087 6.49993"
                stroke="#006894"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Toll Free: </span>
            <a className="rm-contact-phone" href={`tel:+${officePhone}`}>
              {officePhone ? `${officePhone}` : 'Not Available'}
            </a>
          </div>
          <div>
            <svg
              className="rm-email-icon"
              id="Layer_1"
              data-name="Layer 1"
              xmlns="https://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <title>message</title>
              <path d="M21,5H3A2,2,0,0,0,1,7V18a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V7A2,2,0,0,0,21,5Zm0,1a.76.76,0,0,1,.16,0L12,13.36,2.84,6A.76.76,0,0,1,3,6Zm1,12a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a1.07,1.07,0,0,1,.06-.31l9.63,7.7a.49.49,0,0,0,.62,0l9.63-7.7A1.07,1.07,0,0,1,22,7Z" />
            </svg>
            <a className="rm-contact-email" href={`mailTo: ${email}`}>
              {email ? email : 'Not Available'}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactAccountTeam;
